import $ from 'jquery';

const input = $( ".gfield input, .gfield textarea" );

const toggleFocus = ( $el, active ) => {
	const $containingGravityFields = $el.closest( ".gfield, .ginput_complex span" );

	if ( $containingGravityFields.length > 0 && $el.attr( "type" ) !== "file" ) {
		const $containingGravityField = $( $containingGravityFields[ 0 ] );

		if ( active ) {
			return $containingGravityField.addClass( "gfield--focused" );
		}

		return $containingGravityField.removeClass( "gfield--focused" );
	}
};

input.on( "focus", e => {
	toggleFocus( $( e.currentTarget ), true );
} );

input.on( "focusout", e => {
	if ( $( e.currentTarget ).attr( "type" ) === "tel" ) {
		e.currentTarget.value.replace();
	}

	if ( ( e.currentTarget.value === "" && !$( e.currentTarget ).hasClass( "datepicker" ) ) || $( e.currentTarget ).hasClass( "datepicker" ) ) {
		toggleFocus( $( e.currentTarget ), false );
	}
} );

//set non-empty focused on pageload (after submit)
input.each( ( i, el ) => {
	if ( $( el ).val() !== '' ) {
		toggleFocus( $( el ), true );
	}
} );

const plusButton = $( '.form-wrapper__button__amount-button--plus' ),
		minButton = $( '.form-wrapper__button__amount-button--min' ),
		amountInput = $( '.form-wrapper__button__amount-input' );

plusButton.on( 'click', () => {
	let plus = +amountInput.val() + 1;
	amountInput.val( plus );
} );

minButton.on( 'click', () => {
	if ( amountInput.val() > 1 ) {
		let min = +amountInput.val() - 1;
		amountInput.val( min );
	}
} );